<div class="wrap">
  <div class="title">
    <div class="title1">{{ "extras.title" | translate }}</div>
  </div>
  <div *ngFor="let topping of mappedToppings"class="toppings-wrap">
    <div
      class="card-topping"
      (click)="openModal(topping.id)"
    >
      <div class="img-and-topping">
        <div class="img-topping">
          <img class="services-icons" alt="" [src]="topping.icon" />
        </div>
        <div class="info-toppings">
          <div class="title">
            <div class="title2">{{ topping.titleId | translate }}</div>
          </div>
          <div class="pricing">
            <div class="label">
              <div class="title3">{{ "extras.from" | translate }}</div>
            </div>
            <div class="label">
              <div class="title3">{{ getMinimumPrice(topping.products) }}€</div>
            </div>
          </div>
        </div>
      </div>
      <div class="icon">
        <img
          class="iconssolidchevron-right"
          alt=""
          src="assets/icons/chevron-right.svg"
        />
      </div>
    </div>
<!-- Dentro del *ngFor="let topping of mappedToppings" -->
<div
  class="dropdown-dropdown"
  *ngIf="selectedProduct?.id === topping.id"
  (click)="$event.stopPropagation()"
>
  <div class="select-dropdown">
    <div class="wrap-dropdown">
      <div class="title-dropdown">
        <div class="title1-dropdown">{{ "service-added" | translate }}</div>
      </div>
      <div class="quit-dropdown" (click)="removeSelectedProduct($event)">
        <div class="remove-dropdown">{{ "remove" | translate }}</div>
      </div>
    </div>

    <!-- Repostaje -->
    <div class="repostar-dropdown" *ngIf="topping.id === 'refueling'; else defaultSummary">
      <div class="title-dropdown">
        <div class="title2-dropdown">{{ "fuel" | translate }} {{ (selectedProduct?.fuel || '') | translate }}</div>
      </div>
      <div class="title-dropdown">
        <div class="title2-dropdown">{{ "refuel-amount" | translate }} {{ selectedProduct?.amount }}€</div>
      </div>
      <div class="title-dropdown">
        <div class="title3-dropdown">{{ "price" | translate }} {{ selectedProduct?.price | number:'1.2-2' }}€</div>
      </div>
    </div>

    <!-- Otros extras -->
    <ng-template #defaultSummary>
      <div class="repostar-dropdown">
        <div class="title-dropdown">
          <div class="title2-dropdown">{{ (selectedProduct?.name || '') | translate }}</div>
        </div>
        <div class="title-dropdown">
          <div class="title3-dropdown">{{ selectedProduct?.price | number:'1.2-2' }}€</div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
  </div>
</div>

<ng-content select="[left-button]"></ng-content>
<button class="continue-button2" (click)="next()">{{ "next" | translate }}</button>
